import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ChangePasswordService } from 'src/app/Shared/Services/change-password.service';
import { PLChangePassword } from 'src/app/Shared/Model/pl-change-password';
import { platform } from 'os';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  FrmChangePassword: FormGroup;
  PLModel: PLChangePassword;
  UserList: any = []; editedSearch: boolean = false;loginlist: any = []; 
  UserNameshow:boolean=true;UserName:string;

  constructor(private fb: FormBuilder, private MsgService: ToastrService, private router: Router,
    private ChangePasswordServ: ChangePasswordService
  ) { }
  ngOnInit() {
    this.onFrmChangePassword();
    this.FillDDL();
  }
  onFrmChangePassword() {
    this.FrmChangePassword = this.fb.group({
      ddlUserName: ['1', Validators.required],
      txtPassword: ['', Validators.required],
      txtNewPassword: ['', Validators.required],
      txtConfirmPassword: ['', Validators.required],
    })
  }
  FillDDL() {
    this.PLModel = new PLChangePassword()
    this.PLModel.Ind = 1;
   
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
	 this.PLModel.OrgCode = loginlist[0]['OrgCode']; 
    this.PLModel.CityCode =  loginlist[0]['CityCode'];
    this.PLModel.UserId = loginlist[0]['UserId'];
    this.PLModel.LevelId = loginlist[0]['UserLevelId'];

    // this.PLModel.UserName = "";
    // this.PLModel.Password = this.FrmChangePassword.controls['txtPassword'].value;
    // this.PLModel.ConfirmPassword = this.FrmChangePassword.controls['txtConfirmPassword'].value;

    this.ChangePasswordServ.FillDDl(this.PLModel).subscribe(res => {
      if (res) {
        if (res.SuccessCD == 1) {

         
         if(loginlist[0]['UserId']===1 && loginlist[0]['UserLevelId']!==10)
         {
          this.UserList = res.RespData;
          this.UserName='';
          this.FrmChangePassword.controls['ddlUserName'].enable(); 
          this.FrmChangePassword.controls['ddlUserName'].setValue('1');
         }
         else if(loginlist[0]['UserLevelId']===10)
         {
          this.UserName='UserName  :  '+loginlist[0]['UserName'];
          this.FrmChangePassword.controls['ddlUserName'].disable();  
          this.UserNameshow=false;
         }
         else
         {
          this.UserList = res.RespData;
          this.UserName='';
          this.FrmChangePassword.controls['ddlUserName'].setValue(this.PLModel.UserId);
          this.FrmChangePassword.controls['ddlUserName'].disable();         
         }

        } 
      }
    })


  }
  get SubmitDisasble() {

    if (this.FrmChangePassword.controls['txtNewPassword'].value == '' || this.FrmChangePassword.controls['txtNewPassword'].value == null) {
      return true;
    }
    if (this.FrmChangePassword.controls['txtConfirmPassword'].value == '' || this.FrmChangePassword.controls['txtConfirmPassword'].value == null) {
      return true;
    }
    return false;
  }
 
  CheckPwd() { 
    let Password = encodeURIComponent(this.FrmChangePassword.controls['txtPassword'].value);
    let UserId = 0;
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
	
    let OrgCode =loginlist[0]['OrgCode'];   
    let CityCode  = loginlist[0]['CityCode'];
     let LevelId=loginlist[0]['UserLevelId']
    if(LevelId===10)
    {
       UserId = loginlist[0]['UserId'];
    }
    else{
      UserId = this.FrmChangePassword.controls['ddlUserName'].value;
    }
    
    this.ChangePasswordServ.CheckUser(UserId, Password,LevelId, OrgCode, CityCode).subscribe(res => {
      if (res) {
        if (res.SuccessCD == 1 && res.RespData[0]['res'] == 1) {
          this.editedSearch = true;
          this.FrmChangePassword.controls['ddlUserName'].disable();
          this.FrmChangePassword.controls['txtPassword'].disable();


        }
        else if (res.SuccessCD == 1 && res.RespData[0]['res'] == 2) {
          this.editedSearch = false;
          this.MsgService.error('UserName Or Password Does not match...');
         
        }
        else {
          this.editedSearch = false;
          this.MsgService.error('Server Side Error...');
        }

      }
    })

  }
  UpdateChangePassword() {
    if (this.FrmChangePassword.controls['txtNewPassword'].value !== this.FrmChangePassword.controls['txtConfirmPassword'].value) {
      this.MsgService.error('New paasword and Confirm Password does not match...');
      return false;
    }
    this.PLModel.Ind = 2;
   
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
	 this.PLModel.OrgCode =loginlist[0]['OrgCode'];   
    this.PLModel.CityCode = loginlist[0]['CityCode'];
    if(loginlist[0]['UserLevelId']===10)
    {
      this.PLModel.UserId = loginlist[0]['UserId'];
    }
    else{
      this.PLModel.UserId = this.FrmChangePassword.controls['ddlUserName'].value;
    }
    

    this.PLModel.LevelId = loginlist[0]['UserLevelId'];

    this.PLModel.Password = this.FrmChangePassword.controls['txtPassword'].value;
    this.PLModel.ConfirmPassword = this.FrmChangePassword.controls['txtConfirmPassword'].value;

    this.ChangePasswordServ.UpdateChangePassword(this.PLModel).subscribe(res => {
      if (res) {        
        if (res.SuccessCD == 1 && res.RespData[0]['res'] == 1) {
          this.editedSearch = false;
          this.clear();
          this.MsgService.success('Password Updated Successfully...');

        }

        else {
          this.clear();
          this.editedSearch = false;
          this.MsgService.error('Server Side Error...');
        }

      }
    })

  }
  clear() {
    this.FrmChangePassword.controls['ddlUserName'].enable();
    this.FrmChangePassword.controls['txtPassword'].enable();
    this.FrmChangePassword.controls['ddlUserName'].setValue('');
    this.FrmChangePassword.controls['txtPassword'].setValue('');
    this.FrmChangePassword.controls['txtNewPassword'].setValue('');
    this.FrmChangePassword.controls['txtConfirmPassword'].setValue('');
    this.editedSearch = false;
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
   
    if(loginlist[0]['UserId']===1 && loginlist[0]['UserLevelId']!==10)
    {
     this.FrmChangePassword.controls['ddlUserName'].enable(); 
     this.FrmChangePassword.controls['ddlUserName'].setValue('1');
    }
    else if(loginlist[0]['UserLevelId']===10)
    {
     this.FrmChangePassword.controls['ddlUserName'].setValue(loginlist[0]['UserName']) 
     this.FrmChangePassword.controls['ddlUserName'].disable();   
    }
    else
    {
     this.FrmChangePassword.controls['ddlUserName'].setValue(loginlist[0]['UserId']);
     this.FrmChangePassword.controls['ddlUserName'].disable();         
    }
  }
}